import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import i18n from '../i18n/i18n'
Vue.use(Router)
// 路由懒加载

const getComponent = (name, component) => resolve => require([`@/views/${name}/${component}.vue`], resolve)
const getProject = (name, component) => resolve => require([`@/views/project/${name}/${component}.vue`], resolve)
const getModel = (path) => resolve => require([`@/views/model/${path}.vue`], resolve)
const myRouter = new Router({
  routes: [{
    path: '/welcome',
    name: 'welcome',
    component: getComponent('welcome', 'welcomeLayout'),
    children: [
      {
        path: '/welcome/login',
        name: 'login',
        component: getComponent('welcome', 'login'),
        meta: {
          type: 0,
          title: 'Login'
        }
      },
      {
        path: '/welcome/register',
        name: 'register',
        component: getComponent('welcome', 'register'),
        meta: {
          type: 0,
          title: i18n.t('router.Register')
        }
      },
      {
        path: '/Forgot',
        name: 'forgot',
        component: getComponent('welcome', 'forgot'),
        meta: {
          type: 0,
          title: i18n.t('router.Forgot')
        }
      },
      {
        path: '/Forgot/PwdReset/:token?',
        name: 'pwdReset',
        component: getComponent('welcome', 'pwdReset'),
        meta: {
          type: 0,
          title: i18n.t('router.ResetPassword')
        }
      }
    ]
  },
  {
    path: '/role',
    component: getComponent('corp', 'role'),
    name: 'role',
    meta: {
      type: 0,
      title: i18n.t('router.role')
    }
  },
  {
    path: '/welcome/setCorp',
    name: 'setCorp',
    component: getComponent('welcome', 'fakeIndex'),
    meta: {
      type: 0,
      title: i18n.t('router.Register')
    }
  },
  {
    path: '/',
    name: '',
    component: getComponent('layout', 'layout'),
    children: [
      {
        path: '/register',
        name: 'register',
        component: getComponent('login', 'fakeIndex'),
        meta: {
          title: i18n.t('router.Register')
        }
      },
      { // 首页
        path: '/',
        component: getComponent('index', 'home'),
        name: 'index',
        meta: {
          title: i18n.t('router.Projects')
        }
      },
      { // icon
        path: '/icon',
        component: getComponent('tools', 'icon'),
        name: 'icon',
        meta: {
          title: 'icon'
        }
      },
      { // icon
        path: '/diagTest',
        component: getComponent('tools', 'diagTest'),
        name: 'diag',
        meta: {
          title: 'diag'
        }
      },
      {
        path: '/project/:projectId',
        component: getProject('home', 'homePage'),
        name: 'dashboard',
        meta: {
          type: 1,
          title: i18n.t('router.Home')
        }
      },
      {
        path: '/project/:projectId/tasks',
        component: getProject('tasks', 'tasks'),
        name: 'tasks',
        meta: {
          type: 1,
          title: i18n.t('router.Tasks')
        }
      },
      {
        path: '/tasks',
        component: getProject('tasks', 'mainTasks'),
        name: 'mainTasks',
        meta: {
          title: i18n.t('router.Tasks')
        }
      },
      {
        path: '/project/:projectId/diagrams',
        component: getProject('diagrams', 'diagrams'),
        name: 'diagrams',
        meta: {
          type: 1,
          title: i18n.t('router.Plans')
        }
      },
      {
        path: '/project/:projectId/groups',
        component: getProject('group', 'group'),
        name: 'groups',
        meta: {
          type: 1,
          title: i18n.t('router.TaskGroups')
        }
      },
      {
        path: '/project/:projectId/reports',
        component: getProject('report', 'report'),
        name: 'reports-project',
        meta: {
          type: 1,
          title: i18n.t('router.Reports')
        }
      },
      {
        path: '/project/:projectId/analytics',
        component: getProject('report', 'analytics'),
        name: 'analytics',
        meta: {
          type: 1,
          title: i18n.t('router.Liveanalytics')
        }
      },

      {
        path: '/project/:projectId/labors/:laborGroupId?',
        component: getProject('labor', 'laborDetail'),
        name: 'labor',
        meta: {
          type: 1,
          name: 'labors',
          title: i18n.t('static.Labor')
        }
      }, {
        path: '/project/:projectId/labors',
        component: getProject('labor', 'laborGroup'),
        name: 'labors',
        meta: {
          type: 1,
          title: i18n.t('static.Labor')
        }
      },
      {
        path: '/reports',
        component: getProject('report', 'mainReport'),
        name: 'reports-main',
        meta: {
          title: i18n.t('router.Reports')
        }
      },
      {
        path: '/project/:projectId/photos',
        component: getProject('photo', 'photo'),
        name: 'photos',
        meta: {
          type: 1,
          title: i18n.t('router.Photos')
        }
      },
      {
        path: '/project/:projectId/documents',
        component: getProject('document', 'documents'),
        name: 'documents',
        meta: {
          type: 1,
          title: i18n.t('router.Documents')
        }
      },
      {
        path: '/project/:projectId/products',
        component: getProject('products', 'products'),
        name: 'products',
        meta: {
          type: 1,
          title: i18n.t('static.Products')
        }
      },
      {
        path: '/project/:projectId/members',
        component: getProject('member', 'members'),
        name: 'members',
        meta: {
          type: 1,
          title: i18n.t('router.Members')
        }
      },
      {
        path: '/setting/corp',
        component: getComponent('corp', 'corp'),
        name: 'corp',
        meta: {
          title: i18n.t('router.Corp')
        }
      },
      {
        path: '/setting/users',
        component: getComponent('corp', 'user'),
        name: 'users',
        meta: {
          title: i18n.t('router.UserManagement')
        }
      },
      {
        path: '/setting/license',
        component: getComponent('corp', 'license'),
        name: 'license',
        meta: {
          title: i18n.t('router.Subscription')
        }
      },
      {
        path: '/corp/myProfile',
        component: getComponent('corp', 'myProfile'),
        name: 'myProfile',
        meta: {
          title: i18n.t('router.MyProfile')
        }
      },

      {
        path: '/setting/laborItems',
        component: getComponent('corp', 'laborItems'),
        name: 'laborItems',
        meta: {
          title: i18n.t('router.LaborItems')
        }
      },
      {
        path: '/setting/corpSetting',
        component: getComponent('corp', 'corpSetting'),
        name: 'corpSetting',
        meta: {
          title: i18n.t('router.CorpSetting')
        }
      },
      {
        path: '/setting/notificationSetting',
        component: getComponent('corp', 'notificationSetting'),
        name: 'notificationSetting',
        meta: {
          title: i18n.t('router.NotificationSetting')
        }
      },
      {
        path: '/setting/checklistTemplates',
        component: getComponent('corp', 'checklistTemplates'),
        name: 'checklistTemplates',
        meta: {
          title: i18n.t('router.ChecklistTemplates')
        }
      },
      {
        path: '/setting/taskTemplates',
        component: getComponent('corp', 'taskTemplates'),
        name: 'taskTemplates',
        meta: {
          title: i18n.t('router.TaskTemplates')
        }
      },
      {
        path: '/setting/tags',
        component: getComponent('corp', 'tags'),
        name: 'tags',
        meta: {
          title: i18n.t('router.Tags')
        }
      },
      {
        path: '/setting/taskGroupTemplates',
        component: getComponent('corp', 'taskGroupTemplates'),
        name: 'taskGroupTemplates',
        meta: {
          title: i18n.t('router.taskGroupTemplates')
        }
      },
      {
        path: '/management/sysSetting',
        component: getComponent('management', 'systemCategory'),
        name: 'sysSetting',
        meta: {
          title: i18n.t('router.SysSetting')
        }
      },
      {
        path: '/management/corporations',
        component: getComponent('management', 'allCorps'),
        name: 'corporations',
        meta: {
          title: i18n.t('router.Corporations')
        }
      },
      {
        path: '/management/allUsers',
        component: getComponent('management', 'allUsers'),
        name: 'allUsers',
        meta: {
          title: i18n.t('router.AllUsers')
        }
      },
      {
        path: '/management/corporations/:corpId',
        component: getComponent('management', 'userByAdmin'),
        name: 'userByAdmin',
        meta: {
          name: 'corporations',
          title: i18n.t('router.AllUsers')
        }
      }
    ]
  }, {
    path: '*',
    name: '',
    component: getComponent('404', '404')
  }, {
    path: '/project/:projectId/diagrams/:planId',
    name: 'model',
    component: getModel('layout/main'),
    children: [
      {
        path: 'tasks',
        component: getModel('tasklist'),
        name: 'taskList',
        meta: {
          type: 1,
          title: i18n.t('router.TaskList')
        }
      },
      {
        path: 'rooms',
        component: getModel('room'),
        name: 'byRoom',
        meta: {
          type: 1,
          title: i18n.t('router.ByRoom')
        }
      },
      {
        path: 'roomPanel/:roomId?',
        component: getModel('roomPanel'),
        name: 'roomPanel',
        meta: {
          type: 1,
          title: i18n.t('router.room')
        }
      },
      {
        path: 'products',
        component: getModel('product'),
        name: 'byProduct',
        meta: {
          type: 1,
          title: i18n.t('router.ByProduct')
        }
      },
      {
        path: 'tasks/:id?',
        component: getModel('task'),
        name: 'modelTask',
        meta: {
          type: 1,
          title: i18n.t('router.Task')
        }
      }
    ]
  }, {
    path: '/project/:projectId/pdfDiagrams/:planId',
    name: 'model2',
    component: getModel('layout/main2'),
    children: [
      {
        path: 'tasks',
        component: getModel('tasklist'),
        name: 'taskList2',
        meta: {
          type: 1,
          title: i18n.t('router.TaskList')
        }
      },
      {
        path: 'tasks/batch/:type?',
        component: getModel('batch'),
        name: 'batch2',
        meta: {
          type: 1,
          title: i18n.t('router.batchTask')
        }
      },
      {
        path: 'tasks/:id?',
        component: getModel('task'),
        name: 'modelTask2',
        meta: {
          type: 1,
          title: i18n.t('router.Task')
        }
      }
    ]
  }]
})
myRouter.beforeEach((to, from, next) => {
  if (store.state.userInfo.UserId) {
    if (to.path.indexOf('management') === 1 && !store.state.showManagement) {
      next('/')
    } else {
      let redirect = from.query && from.query.redirect ? from.query.redirect : ''
      if (!redirect || to.fullPath === redirect) { // 正常跳转
        if (to.meta.type === 1) { // project菜单需要根据url更新projectId
          store.dispatch('getProject', { jobsiteId: to.params.projectId, planId: to.params.planId }).then(() => {
            next()
          }).catch((e) => {
            if (e.response.data.Status === 401) {
              next({
                path: '/',
                query: { reload: 1, sc: e.response.data.Data.CorpId, projectId: to.params.projectId }
              })
            } else {
              next({
                path: '/',
                query: { reload: 1 }
              })
            }
          })
        } else {
          next()
        }
      } else {
        if (to.query.reload === 1) { // 判断r, 避免redirect死循环
          next()
        } else {
          next({ path: redirect })// redirect到目的路由
        }
      }
    }
  } else {
    if (to.meta && to.meta.type === 0) { // 无需验证
      next()
    } else {
      next({
        path: '/welcome/login',
        query: { redirect: to.fullPath } // 将目的路由地址存入login的query中
      })
    }
  }
})
export default myRouter
